import { FormType, SelectOption } from '../../../shared/models/form';
import { UseFormGetValues } from 'react-hook-form';
import { LocationType } from '../../../shared/models/v1/ApiModel';
import { getLanguage } from '../utils';

const fetchAirports = async (
  currentFieldIndex: number,
  inputValue: string,
  getValues: UseFormGetValues<FormType>,
): Promise<SelectOption[]> => {
  if (inputValue.length < 2) return [];
  try {
    const response = await fetch('api/search', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        currentFieldIndex,
        searchTerm: inputValue,
        bounds: getValues().bounds,
        currency: getValues().currency,
        language: getLanguage(),
      }),
    });

    if (!response.ok) {
      return [];
    }

    const data = (await response.json()) as LocationType[];

    return data.map((location) => ({
      value: location.iataCode,
      label: location.name,
      location: location,
      type: location.type,
    }));
  } catch (error) {
    return [];
  }
};

export default fetchAirports;
